export default __webpack_public_path__ + "static/pm-hero-6fee2381e04c793b521095ef0d890c82.jpg";